import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ShieldCheckIcon, RotateCcwIcon, ClipboardCheckIcon, AlertCircleIcon, CheckIcon } from 'lucide-react';
export function WarrantyPage() {
  const warrantyTerms = [{
    category: 'Басейни та обладнання',
    period: '24 місяці',
    description: 'Офіційна гарантія виробника на всі каркасні та надувні басейни, насоси, фільтри'
  }, {
    category: 'Електрообладнання',
    period: '12-36 місяців',
    description: 'Гарантія на печі для саун, нагрівачі, роботи-пилососи залежно від виробника'
  }, {
    category: 'Хімія та витратні матеріали',
    period: 'До закінчення терміну придатності',
    description: 'Гарантія якості на всю хімію для басейнів та саун'
  }, {
    category: 'Аксесуари',
    period: '6-12 місяців',
    description: 'Гарантія на сходи, термометри, освітлення та інші аксесуари'
  }];
  const returnSteps = [{
    step: 1,
    title: "Зв'яжіться з нами",
    description: 'Напишіть у Telegram або зателефонуйте протягом 14 днів з моменту отримання'
  }, {
    step: 2,
    title: 'Опишіть причину',
    description: 'Розкажіть, чому хочете повернути товар, додайте фото за потреби'
  }, {
    step: 3,
    title: 'Відправте товар',
    description: 'Упакуйте товар в оригінальну упаковку та відправте Новою Поштою'
  }, {
    step: 4,
    title: 'Отримайте кошти',
    description: 'Після перевірки товару повернемо кошти протягом 3-5 робочих днів'
  }];
  return <main className="min-h-screen bg-slate-50" data-id="element-1164">
      {/* Breadcrumbs */}
      <div className="bg-white border-b border-slate-100" data-id="element-1165">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4" data-id="element-1166">
          <nav className="flex items-center gap-2 text-sm" data-id="element-1167">
            <Link to="/" className="text-slate-500 hover:text-slate-700" data-id="element-1168">
              Головна
            </Link>
            <span className="text-slate-300" data-id="element-1169">/</span>
            <span className="text-slate-900 font-medium" data-id="element-1170">
              Гарантія та повернення
            </span>
          </nav>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12" data-id="element-1171">
        {/* Header */}
        <div className="text-center mb-12" data-id="element-1172">
          <h1 className="text-4xl font-bold text-slate-900 mb-4" data-id="element-1173">
            Гарантія та повернення
          </h1>
          <p className="text-lg text-slate-600 max-w-2xl mx-auto" data-id="element-1174">
            Ми гарантуємо якість усіх товарів та забезпечуємо просте повернення
          </p>
        </div>

        {/* Warranty Section */}
        <section className="mb-16" data-id="element-1175">
          <div className="flex items-center gap-3 mb-8" data-id="element-1176">
            <div className="w-12 h-12 bg-sky-100 rounded-xl flex items-center justify-center" data-id="element-1177">
              <ShieldCheckIcon className="w-6 h-6 text-sky-600" data-id="element-1178" />
            </div>
            <h2 className="text-2xl font-bold text-slate-900" data-id="element-1179">
              Гарантійні умови
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-1180">
            {warrantyTerms.map((term, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: index * 0.1
          }} className="bg-white rounded-2xl shadow-md p-6" data-id="element-1181">
                <div className="flex items-start justify-between mb-3" data-id="element-1182">
                  <h3 className="text-lg font-semibold text-slate-900" data-id="element-1183">
                    {term.category}
                  </h3>
                  <span className="px-3 py-1 bg-sky-100 text-sky-700 rounded-lg text-sm font-medium" data-id="element-1184">
                    {term.period}
                  </span>
                </div>
                <p className="text-slate-600" data-id="element-1185">{term.description}</p>
              </motion.div>)}
          </div>
        </section>

        {/* Return Policy */}
        <section className="mb-16" data-id="element-1186">
          <div className="flex items-center gap-3 mb-8" data-id="element-1187">
            <div className="w-12 h-12 bg-sky-100 rounded-xl flex items-center justify-center" data-id="element-1188">
              <RotateCcwIcon className="w-6 h-6 text-sky-600" data-id="element-1189" />
            </div>
            <h2 className="text-2xl font-bold text-slate-900" data-id="element-1190">
              Повернення товару
            </h2>
          </div>

          <div className="bg-white rounded-2xl shadow-md p-6 mb-8" data-id="element-1191">
            <p className="text-slate-600 mb-6" data-id="element-1192">
              Ви можете повернути товар належної якості протягом{' '}
              <strong data-id="element-1193">14 днів</strong> з моменту отримання, якщо він не був у
              використанні, збережено товарний вигляд та оригінальну упаковку.
            </p>

            <div className="grid grid-cols-1 md:grid-cols-4 gap-6" data-id="element-1194">
              {returnSteps.map((step, index) => <div key={index} className="relative" data-id="element-1195">
                  <div className="flex items-center gap-3 mb-3" data-id="element-1196">
                    <span className="w-8 h-8 bg-sky-500 text-white rounded-full flex items-center justify-center text-sm font-bold" data-id="element-1197">
                      {step.step}
                    </span>
                    {index < returnSteps.length - 1 && <div className="hidden md:block absolute top-4 left-10 w-full h-0.5 bg-slate-200" data-id="element-1198" />}
                  </div>
                  <h4 className="font-semibold text-slate-900 mb-2" data-id="element-1199">
                    {step.title}
                  </h4>
                  <p className="text-sm text-slate-600" data-id="element-1200">{step.description}</p>
                </div>)}
            </div>
          </div>
        </section>

        {/* What's Covered */}
        <section className="mb-16" data-id="element-1201">
          <div className="flex items-center gap-3 mb-8" data-id="element-1202">
            <div className="w-12 h-12 bg-sky-100 rounded-xl flex items-center justify-center" data-id="element-1203">
              <ClipboardCheckIcon className="w-6 h-6 text-sky-600" data-id="element-1204" />
            </div>
            <h2 className="text-2xl font-bold text-slate-900" data-id="element-1205">
              Що покриває гарантія
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-1206">
            <div className="bg-emerald-50 rounded-2xl p-6" data-id="element-1207">
              <h3 className="font-semibold text-emerald-800 mb-4 flex items-center gap-2" data-id="element-1208">
                <CheckIcon className="w-5 h-5" data-id="element-1209" />
                Гарантія покриває
              </h3>
              <ul className="space-y-3" data-id="element-1210">
                <li className="flex items-start gap-3 text-emerald-700" data-id="element-1211">
                  <CheckIcon className="w-4 h-4 mt-1 flex-shrink-0" data-id="element-1212" />
                  <span data-id="element-1213">Виробничі дефекти матеріалів</span>
                </li>
                <li className="flex items-start gap-3 text-emerald-700" data-id="element-1214">
                  <CheckIcon className="w-4 h-4 mt-1 flex-shrink-0" data-id="element-1215" />
                  <span data-id="element-1216">Несправності електрообладнання</span>
                </li>
                <li className="flex items-start gap-3 text-emerald-700" data-id="element-1217">
                  <CheckIcon className="w-4 h-4 mt-1 flex-shrink-0" data-id="element-1218" />
                  <span data-id="element-1219">Порушення цілісності при транспортуванні</span>
                </li>
                <li className="flex items-start gap-3 text-emerald-700" data-id="element-1220">
                  <CheckIcon className="w-4 h-4 mt-1 flex-shrink-0" data-id="element-1221" />
                  <span data-id="element-1222">Невідповідність заявленим характеристикам</span>
                </li>
              </ul>
            </div>

            <div className="bg-red-50 rounded-2xl p-6" data-id="element-1223">
              <h3 className="font-semibold text-red-800 mb-4 flex items-center gap-2" data-id="element-1224">
                <AlertCircleIcon className="w-5 h-5" data-id="element-1225" />
                Гарантія не покриває
              </h3>
              <ul className="space-y-3" data-id="element-1226">
                <li className="flex items-start gap-3 text-red-700" data-id="element-1227">
                  <AlertCircleIcon className="w-4 h-4 mt-1 flex-shrink-0" data-id="element-1228" />
                  <span data-id="element-1229">Механічні пошкодження з вини покупця</span>
                </li>
                <li className="flex items-start gap-3 text-red-700" data-id="element-1230">
                  <AlertCircleIcon className="w-4 h-4 mt-1 flex-shrink-0" data-id="element-1231" />
                  <span data-id="element-1232">Пошкодження через неправильну експлуатацію</span>
                </li>
                <li className="flex items-start gap-3 text-red-700" data-id="element-1233">
                  <AlertCircleIcon className="w-4 h-4 mt-1 flex-shrink-0" data-id="element-1234" />
                  <span data-id="element-1235">Природний знос витратних матеріалів</span>
                </li>
                <li className="flex items-start gap-3 text-red-700" data-id="element-1236">
                  <AlertCircleIcon className="w-4 h-4 mt-1 flex-shrink-0" data-id="element-1237" />
                  <span data-id="element-1238">Самостійний ремонт або модифікації</span>
                </li>
              </ul>
            </div>
          </div>
        </section>

        {/* Contact for Warranty */}
        <section data-id="element-1239">
          <div className="bg-sky-50 rounded-2xl p-8 text-center" data-id="element-1240">
            <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-1241">
              Потрібна допомога з гарантією?
            </h2>
            <p className="text-slate-600 mb-6 max-w-xl mx-auto" data-id="element-1242">
              Напишіть нам у Telegram з описом проблеми та фото товару —
              допоможемо вирішити питання якнайшвидше
            </p>
            <a href="https://t.me/aquapools_if" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 px-6 py-3 bg-sky-500 text-white rounded-xl font-medium hover:bg-sky-600 transition-colors" data-id="element-1243">
              Написати в Telegram
            </a>
          </div>
        </section>
      </div>
    </main>;
}